import { Link, useLocation } from "react-router-dom";
import { MODE_NAV } from "./Sidebar";

/** Step 32: mobile bottom navigation for the 6 modes. Visible only
 *  under md (the desktop rail handles >= md). Fixed to the bottom
 *  edge; the routed <main> reserves pb-20 on mobile so content is
 *  never hidden behind it. Settings stays off the bar (reached via
 *  the user menu / gear in the drawer). No em dashes. */
export function ModeBottomBar() {
  const { pathname } = useLocation();
  return (
    <nav
      aria-label="Primary"
      className="md:hidden fixed bottom-0 left-0 right-0 z-30 glass-bar backdrop-blur border-t border-slate-200/70 dark:border-slate-700/40 flex items-stretch justify-around px-1 pb-[env(safe-area-inset-bottom)]"
    >
      {MODE_NAV.map((m) => {
        const active = m.matches(pathname);
        return (
          <Link
            key={m.to}
            to={m.to}
            aria-current={active ? "page" : undefined}
            className={`flex-1 flex flex-col items-center justify-center gap-0.5 py-2 min-w-0 ${
              active
                ? "text-sky-600 dark:text-sky-400"
                : "text-slate-500 dark:text-slate-400"
            }`}
          >
            <m.Icon
              className={`w-5 h-5 ${active ? "" : m.inactiveIconColor}`}
            />
            <span className="text-[10px] font-semibold truncate max-w-full">
              {m.label}
            </span>
          </Link>
        );
      })}
    </nav>
  );
}
